import { UnknownError } from '@cian/peperrors/shared';

import { TAddFavoriteResponse } from '../../../../repositories/favorites/v1/add-favorite';

export const assertUnknownError = (response: TAddFavoriteResponse): void => {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/favorite/addFavorite#assertUnknownError()',
    message: message || '',
    details: {
      errors: JSON.stringify(errors),
    },
  });
};
